import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { InfoCardComponent } from "@shared/components/info-card/info-card.component";
import { EMAIL } from "@shared/constants/localstorage.constants";
import { EMAIL_REGEX } from "@shared/constants/validators.constants";
import { MembersService } from "@shared/services/members.service";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "app-password-forgotten",
  standalone: true,
  templateUrl: "./password-forgotten.component.html",
  styleUrls: ["./password-forgotten.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    ButtonModule,
    InputTextModule,
    TranslateModule,
    InfoCardComponent,
  ],
})
export class PasswordForgottenComponent implements OnInit {
  constructor(private membersService: MembersService) {}

  public formGroup: FormGroup = new FormGroup({
    email: new FormControl<string | null>(null, {
      validators: [Validators.required, Validators.pattern(EMAIL_REGEX)],
      nonNullable: true,
    }),
  });

  emailExists = false;
  isEmailSent = false;
  loading = false;
  showUnknown = false;

  get email() {
    return this.formGroup.get(EMAIL);
  }

  ngOnInit() {
    this.email?.valueChanges.subscribe(() => {
      this.emailExists = false;
      this.showUnknown = false;
      if (this.email?.valid) {
        this.checkEmail();
      }
    });
  }

  sendEmail() {
    console.log("sending email...");
    this.loading = true;
    this.membersService.sendPasswordResetEmail(this.email?.value).subscribe(() => {
      this.isEmailSent = true;
      this.loading = false;
    });
  }

  checkEmail() {
    this.loading = true;
    this.membersService.emailExists(this.email?.value).subscribe(exists => {
      this.emailExists = exists;
      this.showUnknown = !exists;
      this.loading = false;
    });
  }
}
